import { DocumentService } from "models/wizard/WizardState";
import { CustomerDocuments } from "./documents";

export type SalesPerson = {
  isFixedRecipient?: boolean;
  id: string;
  email: string;
  givenName: string;
  surName: string;
  adId: string;
  role: string;
  isSalePerson: boolean;
  visibleForCustomer: boolean;
  employeeNumber: string;
  socialSecurityNumber: string;
  outOfOfficeMessage: string;
  organization: string;
};
export type Invitation = {
  lastInvitaionSentAt: Date;
};

export enum ExternalUserRole {
  Admin = 1,
  User = 2,
  Accounting = 3,
  Payroll = 4
}

export type ExternalUser = {
  isFixedRecipient?: boolean;
  outOfOfficeMessage?: string;
  createdAt?: Date;
  email: string;
  givenName: string;
  id: string;
  invitation?: Invitation;
  lastAccess: Date;
  roles: ExternalUserRole[];
  socialSecurityNumber: string;
  surName: string;
  verified: boolean;
  verifiedAt: Date;
  isSalePerson?: boolean;
  sendInvite?: boolean;
  sendNotification?: boolean;
  isNewUser?: boolean;
  entraObjectId?: string;
};

export type MessageSummary = {
  unreadCount: number;
  lastMessageDateTime: Date;
};

export type FilesSummary = {
  unhandledCount: number;
  lastFileDateTime: Date;
};

export type ContactInformation = {
  address1: string;
  zipCode: string;
  city: string;
  phone: string;
};

export type MyCustomer = {
  state: string;
  customerId: string;
  customerName: string;
  salesPerson: SalesPerson;
  lastAccess: Date;
  customerNumber: string;
  isPrivate: boolean;
  organizationNumber: string;
  lastAccessExternal: Date;
  lastAccessExternalName: string;
  messagesSummary?: MessageSummary;
  filesSummary?: FilesSummary;
  requestedAddToCustomer?: boolean;
};

export type FavoriteCustomer = {
  userId: string;
  customerId: string;
};

export type CustomerState = {
  id: string;
  customerId: string;
  isLoading: boolean;
  contactInformation: ContactInformation;
  fpService: any;
  activeProjectTypes: string[];
  organizationNumber?: string;
  customerName: string;
  customerNumber: string;
  externalUsers: ExternalUser[];
  internalUsers: SalesPerson[];
  state: string;
  closingAt: Date;
  documentServices: DocumentService[];
  documents: {
    data?: CustomerDocuments;
    emails?: { [key: string]: number };
    categories?: { [key: string]: number };
    total?: number;
    isLoading: boolean;
    currentPage: number;
    pageSize: number;
    totalFiltered?: number;
  };
  acceptedTerms?: boolean;
};

export type MyCustomers = {
  isLoading: boolean;
  customers: MyCustomer[];
  unfilteredCustomers: MyCustomer[];
};

export type AllCustomers = {
  isLoading: boolean;
  customers: MyCustomer[];
  imported:
    | {
        status: string;
        customerId: string;
        customerName: string;
        userIsSalesPerson: boolean;
        salesPersonName: string;
        message: string;
      }
    | object;
};

export type CustomerServerSettings = {
  notification?: string[];
  outOfOfficeMessage: string;
  isSendingActivation?: boolean;
  isActivated?: boolean;
};
